import { PureComponent } from "react";
import { TrackingScripts } from "/components/core/head/tracking-scripts";
import FullstoryScript from "/components/core/head/fullstory-scripts/fullstory-script";
import TrustpilotScript from "/components/core/head/seo-scripts/trustpilot-script";
import IntercomScript from "/components/core/head/intercom-scripts/intercom-script";
import { initBodyScripts } from "services/body-scripts-service";
import { withAbTests } from "/contexts/ab-tests-context";
import GoogleTagManagerComponent from "/components/core/google-tag-manager/google-tag-manager-component";
import DriftScript from "/components/core/head/drift-script";
import HotjarScript from "/components/core/head/hotjar-script";
import GoogleOnetapScript from "/components/core/head/google-onetap-script";

const isProduction = process.env.NODE_ENV === "production";
const HotjarWithAbTests = withAbTests(HotjarScript);

class BodyScriptsComponent extends PureComponent {
  componentDidMount() {
    const { abTests } = this.props;
    initBodyScripts({
      abTests
    });
  }

  shouldLoadDriftScript() {
    const { enableDriftChatBot } = this.props;
    return enableDriftChatBot; //can add drift ab test code here || abTest
  }

  render() {
    const {
      withFullstory,
      fullstoryRecordingFrequency,
      showTrustpilotReviews,
      withIntercom,
      fontLazyLoad,
      fontFamily,
      template,
      disableGTM,
      gtmContainerId,
      enableDriftChatBot,
      enableHotjar,
      pagePath,
      clusterId,
      hasFreeTier,
      localeId,
      subClusterId,
      enableGoogleOneTap,
      isMobileOrTabletBrowser,
    } = this.props;
    let { loggedInUser } = this.props;
    loggedInUser = loggedInUser || {};

    return (
      <>
        {isProduction && (
          <>
            {!disableGTM && (
              // This MUST be rendered in the body so componentDidMount will run
              <GoogleTagManagerComponent loadBodyScript={true} gtmId={gtmContainerId} />
            )}
            {TrackingScripts.map((TrackingScript) => {
              return <TrackingScript key={TrackingScript.name} />;
            })}
            {withFullstory && (
              <FullstoryScript
                clusterId={clusterId}
                subClusterId={subClusterId}
                fullstoryRecordingFrequency={fullstoryRecordingFrequency}
                hasFreeTier={hasFreeTier}
                localeId={localeId}
              />
            )}
            {showTrustpilotReviews && <TrustpilotScript />}
            {withIntercom && (
              <IntercomScript
                userData={{
                  userId: loggedInUser.mondayUserId || loggedInUser.id,
                  name: loggedInUser.name,
                  email: loggedInUser.email,
                  additionalData: loggedInUser.intercomData
                }}
                isProduction={isProduction}
              />
            )}
            {this.shouldLoadDriftScript() && (
              <DriftScript Cluster={clusterId} subClusterId={subClusterId} shouldShowOnLoad={enableDriftChatBot} />
            )}
            {enableHotjar && <HotjarWithAbTests />}
          </>
        )}
        {enableGoogleOneTap && !isMobileOrTabletBrowser && <GoogleOnetapScript />}
      </>
    );
  }
}

export default withAbTests(BodyScriptsComponent);

BodyScriptsComponent.defaultProps = {
  withFullstory: false,
  showTrustpilotReviews: false,
  withIntercom: false,
  fontLazyLoad: false,
  disableGTM: false
};
